import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        console.log("Fetching blog with id:", id);

        const res = await axios.get(`${API_BASE_URL}/posts/${id}`);
        console.log("Raw API response:", res.data);

        const blogData = res.data?.post;

        if (!blogData) {
          throw new Error("No blog found for this id");
        }

        setBlog(blogData);
      } catch (err) {
        console.error("Error fetching blog:", err);
        setError(err.message || "Failed to fetch blog");
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) return <div className="text-center mt-5">Loading blog...</div>;
  if (error) return <p className="text-danger text-center mt-5">Error: {error}</p>;
  if (!blog) return <p className="text-center mt-5">No blog data found.</p>;

  return (
    <>
    <Navbar/>
    <div className="py-4"></div>
        <div className="container my-5 ">
      <div className="card shadow-lg border-0 rounded-4 p-4">
        {blog.imageUrl && (
          <img
            src={blog.imageUrl}
            alt={blog.title}
            className="card-img-top rounded-4 mb-4"
            style={{ maxHeight: "400px", objectFit: "cover" }}
          />
        )}

        <div className="card-body">
          <h1 className="card-title fw-bold mb-3">{blog.title}</h1>

          <p className="text-seco mb-2">
            <b>Author:</b> {blog.author}
          </p>

          <p className="card-text fs-5">{blog.content}</p>

          {blog.createdAt && (
            <div className="mt-4">
              <small className="text-secondary d-block pb-1">
                📅 Published: {new Date(blog.createdAt).toLocaleDateString()}
              </small>
              <small className="text-secondary d-block">
                ✏️ Updated: {new Date(blog.updatedAt).toLocaleDateString()}
              </small>
            </div>
          )}
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default BlogDetail;
